import React, { useState } from "react";
import Modal from 'react-modal';
import { customStylesModal } from './selectStyle';

const ModalYesNo = (props) => {
  const [modalIsOpen] = useState(props.show);
  const handleSubmit = (type) => {
    props.handleYesNoAnswer(type);
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={props.closeModal}
      style={customStylesModal}
      contentLabel="Custom modal"
      ariaHideApp={false}
    >
      <div className='modal-header'>
        <div className="modal-close"><i className="fa fa-times-circle" aria-hidden="true" onClick={props.closeModal}></i></div>
        <h5>{props.heading}</h5>
      </div>
      <div className="modal-body">
        <h5>{props.text}</h5>
      </div>
      <div className="modal-footer">
        <button type="submit" className="btn btn-blue" onClick={() => { handleSubmit('yes') }}> Yes</button>
        <button type="submit" className="btn btn-grey" onClick={() => { handleSubmit('no') }}>No</button>
      </div>
    </Modal>
  );
}

export default ModalYesNo;


// WEBPACK FOOTER //
// ./src/components/shared/modalYesNo.js